import { render, staticRenderFns } from "./QStoredProcDataTableBase.vue?vue&type=template&id=6146b802&scoped=true&"
import script from "./QStoredProcDataTableBase.vue?vue&type=script&lang=js&"
export * from "./QStoredProcDataTableBase.vue?vue&type=script&lang=js&"
import style0 from "./QStoredProcDataTableBase.vue?vue&type=style&index=0&id=6146b802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6146b802",
  null
  
)

export default component.exports